import { createTheme } from '@mui/material/styles'

import '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Theme {}

  // allow configuration using `createTheme`
  interface ThemeOptions {}

  interface Palette {
    icon: Palette['primary']
  }

  interface PaletteOptions {
    icon: PaletteOptions['primary']
  }
}

const typography = {
  fontFamily: ['-apple-system', 'IRANYekan', 'Roboto'].join(','),
}

const palette = {
  primary: { main: '#0985f4' },
  secondary: { main: '#3bffc1' },
  text: {
    main: 'black',
    secondary: '#515151',
    light: 'white',
  },
  icon: {
    main: '#2d2d2d',
    light: 'white',
  },
}

export const theme = createTheme({
  direction: 'rtl',
  palette,
  typography,
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
  },
})
